import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import ArrowSelect from "rialto-icons/ArrowSelect";

import { Translate } from "utils";

import DropdownTag from "./DropdownTag";

import styles from "./DropdownMultiSelect.css";

const { t } = new Translate();

const DropdownMultiSelect = ({ isEdit, isRequired, limit, placeholder, tags }) => {
  const tagsShown = limit ? tags.slice(0, limit) : tags;
  const tagsHidden = tags.length - tagsShown.length;

  const content =
    isEdit && !tags.length ? (
      <span className={styles.placeholder}>{placeholder}</span>
    ) : (
      <div>
        {tagsShown.map((tag, index) => (
          <DropdownTag content={tag} key={index} />
        ))}
        {tagsHidden ? (
          <span className={styles.more}>
            +&nbsp;{tagsHidden} {t("more")}
          </span>
        ) : null}
      </div>
    );

  return (
    <div className={styles.root}>
      {isEdit ? (
        <div
          className={cx(styles.edit, {
            [styles.required]: isRequired && !tags.length,
          })}
        >
          <div className={styles.tags}>{content}</div>
          <div className={styles.arrowSelect}>
            <ArrowSelect size="xs" />
          </div>
        </div>
      ) : (
        content
      )}
    </div>
  );
};

DropdownMultiSelect.propTypes = {
  limit: PropTypes.number,
  tags: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  isEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string,
};

DropdownMultiSelect.defaultProps = {
  tags: [],
  placeholder: "",
};

export default DropdownMultiSelect;
